import { Route, Routes as RouterRoutes } from 'react-router-dom';
import { Clusters } from '../pages/Clusters';
import { CodeSignUp } from '../pages/CodeSignUp';
import { EnterCode } from '../pages/EnterCode';
import { ExpiredCluster } from '../pages/ExpiredCluster';
import { GiftCheckEmail } from '../pages/GiftCheckEmail';
import { Landing } from '../pages/Landing';
import { Login } from '../pages/Login';
import { Logout } from '../pages/Logout';
import { Merchants } from '../pages/Merchants';
import { NotFound } from '../pages/NotFound';
import { Offers } from '../pages/Offers';
import {RedirectToProps} from "../pages/RedirectToProps/RedirectToProps";
import { ResetPassword } from '../pages/ResetPassword';
import { SeasonCampaign } from '../pages/SeasonCampaign';
import { SignUp } from '../pages/SignUp';
import { VerifyEmail } from '../pages/VerifyEmail';
import AppRoutes from './appRoutes';
import { OpenRoute } from './components/OpenRoute';
import { ProtectedRoute } from './components/ProtectedRoute';

// TODO: create new wrapper for Protected/Open route because now it looks messy af thanks to v6
export const Routes = () => {
  return (
    <RouterRoutes>
      <Route path={AppRoutes.NOT_FOUND} element={<RedirectToProps />} />
    </RouterRoutes>
  );

    // return (
    //     <RouterRoutes>
    //         {/* Routes */}
    //         <Route path={AppRoutes.HOME} element={<Clusters />} />
    //         <Route path={AppRoutes.ENTER_CODE} element={<EnterCode />} />
    //         <Route path={AppRoutes.LANDING} element={<Landing />} />
    //         <Route path={AppRoutes.NOT_FOUND} element={<NotFound />} />
    //         {/* ProtectedRoute */}
    //         <Route
    //             path={AppRoutes.MERCHANTS}
    //             element={
    //                 <ProtectedRoute path={AppRoutes.MERCHANTS}>
    //                     <Merchants />
    //                 </ProtectedRoute>
    //             }
    //         />
    //         <Route
    //             path={AppRoutes.OFFERS}
    //             element={
    //                 <ProtectedRoute path={AppRoutes.OFFERS}>
    //                     <Offers />
    //                 </ProtectedRoute>
    //             }
    //         />
    //         <Route
    //             path={AppRoutes.LOGOUT}
    //             element={
    //                 <ProtectedRoute path={AppRoutes.LOGOUT}>
    //                     <Logout />
    //                 </ProtectedRoute>
    //             }
    //         />
    //         <Route
    //             path={AppRoutes.CLUSTER_EXPIRED}
    //             element={
    //                 <ProtectedRoute
    //                     path={AppRoutes.CLUSTER_EXPIRED}
    //                     redirectRoute={AppRoutes.LANDING}>
    //                     <ExpiredCluster />
    //                 </ProtectedRoute>
    //             }
    //         />
    //         <Route
    //             path={AppRoutes.SEASON_CAMPAIGN}
    //             element={
    //                 <ProtectedRoute path={AppRoutes.SEASON_CAMPAIGN}>
    //                     <SeasonCampaign />
    //                 </ProtectedRoute>
    //             }
    //         />
    //         <Route
    //             path={AppRoutes.GIFT_CHECK_EMAIL}
    //             element={
    //                 <ProtectedRoute path={AppRoutes.GIFT_CHECK_EMAIL}>
    //                     <GiftCheckEmail />
    //                 </ProtectedRoute>
    //             }
    //         />
    //         {/* OpenRoute */}
    //         <Route
    //             path={AppRoutes.CODE_SIGNUP}
    //             element={
    //                 <OpenRoute path={AppRoutes.CODE_SIGNUP}>
    //                     <CodeSignUp />
    //                 </OpenRoute>
    //             }
    //         />
    //         <Route
    //             path={AppRoutes.LOGIN}
    //             element={
    //                 <OpenRoute path={AppRoutes.LOGIN}>
    //                     <Login />
    //                 </OpenRoute>
    //             }
    //         />
    //         <Route
    //             path={AppRoutes.SIGNUP}
    //             element={
    //                 <OpenRoute path={AppRoutes.SIGNUP}>
    //                     <SignUp />
    //                 </OpenRoute>
    //             }
    //         />
    //         <Route
    //             path={AppRoutes.VERIFY_EMAIL}
    //             element={
    //                 <OpenRoute path={AppRoutes.VERIFY_EMAIL}>
    //                     <VerifyEmail />
    //                 </OpenRoute>
    //             }
    //         />
    //
    //         <Route
    //             path={AppRoutes.RESET_PASSWORD}
    //             element={
    //                 <OpenRoute path={AppRoutes.RESET_PASSWORD}>
    //                     <ResetPassword />
    //                 </OpenRoute>
    //             }
    //         />
    //     </RouterRoutes>
    // );
};
